"use strict";

var _taggedTemplateLiteral = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: column nowrap;\n    place-content: flex-start;\n    align-items: flex-start;\n    cursor: inherit;\n    line-height: 15px;\n    font-size: 13px;\n\n    & > :not(:last-child) {\n      margin-bottom: 8px;\n    }\n\n    & > span {\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n    user-select: none;\n    margin-left: auto;\n    display: flex;\n\n    &:hover {\n      color: #8698a7;\n    }\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 50px;\n    width: 50px;\n    border-radius: 10%;\n    border: 1px solid #d0d7dd;\n    box-sizing: border-box;\n\n    object-fit: cover;\n    object-position: center center;\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row nowrap;\n    place-content: flex-start;\n    align-items: center;\n    padding: 8px;\n    cursor: inherit;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    margin-bottom: 4px;\n    box-sizing: border-box;\n\n    & > :not(:last-child) {\n      margin-right: 8px;\n    }\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    line-height: 20px;\n    font-size: 13px;\n    font-weight: 400;\n    margin-top: 10px;\n    color: #9e9e9e;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    font-size: 20px;\n    font-weight: 400;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border: 1px dashed #bdbdbd;\n    margin: 10px 30px 30px 30px;\n    flex: 1;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    font-size: 13px;\n    font-weight: 400;\n    margin: auto;\n    margin-left: 0;\n    margin-right: auto !important;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row nowrap;\n    place-content: flex-start flex-end;\n    align-items: flex-start;\n    padding: 16px;\n    cursor: inherit;\n    margin-top: auto;\n    border-top: 1px solid #dddddd;\n\n    & > :not(:last-child) {\n      margin-right: 8px;\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: column nowrap;\n    place-content: flex-start;\n    align-items: flex-start;\n    margin: 16px 16px 0 16px;\n    padding-bottom: 12px;\n    cursor: inherit;\n    overflow: auto;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 13px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    cursor: inherit;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    min-height: 40px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n    user-select: none;\n    margin-right: 8px;\n    margin-left: auto;\n\n    &:hover {\n      color: #8698a7;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: #ff0000; // Red color for error messages\n  font-size: 14px;\n  margin-top: 8px;\n  text-align: center;  // Center-align the text\n  padding: 16px;       // Add padding for better visual appeal\n  border: 1px solid #ff0000;  // Add border for emphasis\n  border-radius: 8px;  // Add border-radius for rounded corners\n  background-color: #ffe6e6;  // Light red background color\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    appearance: none;\n    outline: none;\n    text-align: center;\n    text-decoration: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    user-select: none;\n    white-space: nowrap;\n    color: rgb(255, 255, 255);\n    line-height: 20px;\n    font-weight: 600;\n    letter-spacing: 0.2px;\n    transition: all 0.15s ease-in-out 0s;\n    cursor: pointer;\n    border-radius: 5px;\n    border-style: solid;\n    border-width: 1px;\n    background-color: rgb(8, 116, 249);\n    border-color: rgb(8, 116, 249);\n    height: 40px;\n    padding: 0px 32px;\n    font-size: 14px;\n    &:active {\n      background-color: rgb(77, 161, 255);\n      border-color: rgb(77, 161, 255);\n      box-shadow: rgb(50 50 93 / 14%) 0px 1px 3px 0px inset,\n        rgb(51 80 107 / 8%) 0px 4px 6px 0px inset;\n    }\n\n    &:hover {\n      background-color: rgb(35, 139, 255);\n      border-color: rgb(35, 139, 255);\n      box-shadow: rgb(50 50 93 / 20%) 0px 2px 4px 0px;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILE_PREVIEW_STYLES = exports.DROPZONE_STYLES = exports.CONTENT_STYLES = exports.ERROR_STYLES = exports.COMMON_STYLES = void 0;

var css_1 = require("@emotion/css");

exports.COMMON_STYLES = {
  button: (0, css_1.css)(_templateObject())
};
exports.ERROR_STYLES = (0, css_1.css)(_templateObject2());
exports.CONTENT_STYLES = {
  closeWrapper: (0, css_1.css)(_templateObject3()),
  header: (0, css_1.css)(_templateObject4()),
  headerTitle: (0, css_1.css)(_templateObject5()),
  listWrapper: (0, css_1.css)(_templateObject6()),
  footer: (0, css_1.css)(_templateObject7()),
  footerDetails: (0, css_1.css)(_templateObject8())
};
exports.DROPZONE_STYLES = {
  wrapper: (0, css_1.css)(_templateObject9()),
  title: (0, css_1.css)(_templateObject10()),
  description: (0, css_1.css)(_templateObject11())
};
exports.FILE_PREVIEW_STYLES = {
  itemWrapper: (0, css_1.css)(_templateObject12()),
  image: (0, css_1.css)(_templateObject13()),
  removeWrapper: (0, css_1.css)(_templateObject14()),
  details: (0, css_1.css)(_templateObject15())
};